var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app',[_c('dashboard-core-app-bar'),_c('dashboard-core-drawer'),_c('dashboard-core-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }